module.exports = __webpack_public_path__ + "img/login-visual.92c65567.png";